import {Preloader, PreloaderProps} from '@genestack/ui';
import React from 'react';

import {ListPreloaderItem} from './list-preloader-item';

/** Preloader component for ontology documents */
export function ListItemPreloader(props: PreloaderProps) {
    return <Preloader count={1} wrapEach={ListPreloaderItem} box="block" {...props} />;
}
